import { styled } from '@mui/material/styles';
import React, { ReactNode } from 'react';

const PREFIX = 'VerticalScroll';

const classes = {
  container: `${PREFIX}-container`,
  content: `${PREFIX}-content`
};

const Root = styled('div')(() => ({
  [`& .${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flex: 1
  },

  [`& .${classes.content}`]: {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '7px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: '3px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555'
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: '3px'
    },
    scrollbarColor: '#888 #f1f1f1',
    scrollbarWidth: 'thin'
  }
}));

interface VerticalScrollProps {
  children: ReactNode;
  containerClassName?: string;
  contentClassName?: string;
}

const VerticalScroll = ({
  children,
  contentClassName = '',
  containerClassName = ''
}: VerticalScrollProps) => {
  return (
    <Root sx={{ display: 'flex', overflow: 'hidden', width: '100%' }}>
      <div
        className={
          containerClassName !== ''
            ? `${classes.container} ${containerClassName}`
            : classes.container
        }
      >
        <div
          className={
            contentClassName !== '' ? `${classes.content} ${contentClassName}` : classes.content
          }
        >
          {children}
        </div>
      </div>
    </Root>
  );
};

export default VerticalScroll;
